<template>
  <div>
    <ExtEnvComponent></ExtEnvComponent>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardBody class="p-2">
            <CForm inline>
              <!--              <label class="col-form-label ml-2 mr-2"></label>-->
              <CSelect
                :value.sync="inFacilityId"
                :options="inFacilityList"
                style="margin-bottom: 0; width: 97%"
                class="ml-2 ml-sm-0 w-auto-sm"
              >
              </CSelect>
              <div class="ml-auto"></div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol col="12">
        <InEnvChartCard :properties="properties.inEnvChartCard"></InEnvChartCard>
      </CCol>

      <CCol col="12">
        <InEnvRecommCard :properties="properties.recommCard"></InEnvRecommCard>
      </CCol>

      <CCol col="12">
        <ControlCard
          header-html="<strong style='line-height: 2.3'>제어</strong>"
        ></ControlCard>
      </CCol>

      <CCol col="12">
        <InEnvVideoCard></InEnvVideoCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import ExtEnvComponent from "@/components/monitoring/ExtEnvComponent";
import InEnvVideoCard from "@/components/dashboard/InEnvVideoCard";
import ControlCard from "@/components/control/ControlCard";
import MixinsInFacility from "@/mixins/in-facility";
import InEnvChartCard from "@/components/dashboard/InEnvChartCard";
import core from "@/core";
import SensorService from "@/services/sensor/sensor.service";
import InEnvRecommCard from "@/components/dashboard/InEnvRecommCard";

export default {
  name: "Dashboard",
  components: {
    InEnvRecommCard,
    InEnvChartCard,
    ControlCard,
    InEnvVideoCard,
    ExtEnvComponent,
  },
  mixins: [MixinsInFacility()],
  data() {
    return {
      properties: {
        recommCard: {
          initFlag: false,
          inEnvList: [],
        },
        inEnvChartCard: {
          initFlag: false,
          inEnvList: [],
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.properties.recommCard.initFlag = true;
      // this.properties.inEnvChartCard.initFlag = true;
    });
  },
  watch: {
    inFacilityId(val) {
      console.log("changed inFacilityId");
      if (val != null) {
        this.getSensorData().then((data) => {
          //console.log("data : ", data);
          this.properties.recommCard.inEnvList = data;
          this.properties.inEnvChartCard.inEnvList = data;
        });
      }
    },
  },
  methods: {
    async getSensorData() {
      const inFacilityId = this.inFacilityId;
      if (inFacilityId == null) {
        console.log("inFacilityId is null");
        return null;
      }

      const startMoment = core.date.instance();
      const endMoment = core.date.instance().add(1, "days");
      const list = await SensorService.getInEnvList({
        inFacilityId: inFacilityId,
        sensingAtGreaterThanEqual: startMoment.format("YYYY-MM-DD"),
        sensingAtLessThan: endMoment.format("YYYY-MM-DD"),
      });
      list.forEach((sensor) => {
        sensor.date = core.date.instance(sensor.sensingAt).toDate();
      });

      return list;
    },
  },
};
</script>
